module.exports = __webpack_public_path__ + "img/9788952233271.58983fc3.jpg";